import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as _ from 'lodash';

import { MediaViewModel } from '../models/MediaViewModel';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  constructor(private _httpClient: HttpClient) {}

  uploadMedia(mediaType: number, file: File, isTemp: boolean = true): Observable<MediaViewModel> {
    let url = `api/Media?mediaType=${mediaType}&isTemp=${isTemp}`;
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this._httpClient.post<MediaViewModel>(url, formData).pipe(catchError(this.handleError));
  }

  // Utility
  private handleError(error: HttpErrorResponse) {
    console.error(error);
    let customError: string = '';
    if (error.error) {
      customError = error.status === 400 ? error.error : error.statusText;
    }
    return throwError(customError || 'Server error');
  }

  getExtensionImage(filename: string) {
    let filenameLower = filename.toLowerCase();
    if (filenameLower.endsWith('.pdf')) {
      return '/assets/images/pdf.png';
    }
    if (filenameLower.endsWith('.doc') || filenameLower.endsWith('.docx')) {
      return '/assets/images/word.png';
    }
    if (filenameLower.endsWith('.xls') || filenameLower.endsWith('.xlsx')) {
      return '/assets/images/excel.png';
    }
    if (filenameLower.endsWith('.ppt') || filenameLower.endsWith('.pptx')) {
      return '/assets/images/powerpoint.png';
    }
    if (filenameLower.endsWith('.jpg') || filenameLower.endsWith('.jpeg') || filenameLower.endsWith('.png') || filenameLower.endsWith('.gif') || filenameLower.endsWith('.bmp')) {
      return '/assets/images/image.png';
    }
    return '/assets/images/document.png';
  }
}
